import React, { useEffect, useRef, useState } from "react";
import "./Report.scss";
import { FaRegEdit } from "react-icons/fa";
import { MdNotificationsNone, MdOutlineDelete } from "react-icons/md";
import { useQuery } from "@tanstack/react-query";
import {
  createUserActivityReports,
  deleteProject,
  getAddNewTaskDetail,
  getOnGoingTask,
  getOverDueTask,
  getReports,
  getUnderReviewTask,
  getUpComingTask,
  listOfProject,
  removeTask,
} from "../../apiCall";
import { CgAttachment } from "react-icons/cg";
import toast from "react-hot-toast";
import { ConfirmationModal } from "../../components/Modals/ConfirmationModal";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useStateValue } from "../../StateProvider";
import { isAdmin } from "../../utils/adminAccess";
import {
  getClassNamesOfEndDate,
  getClassNamesOfStartDate,
  getClassNamesOfStatus,
} from "../../utils/colorCode";
import { IoMdSearch } from "react-icons/io";
import { formatDateTimetoAmPm, formatTimeDuration } from "../../utils/FormateDate";
import { useForm } from "react-hook-form";
import { generateExcel } from "../../utils/downloadReports";
import { convertToUserOptions, customStyles } from "../../utils/ConvertToOptions";
import Select from 'react-select'

// function formatTimeDuration(duration) {
//   if (!duration) return "--";

//   const parts = duration.split(" "); // Split the input string by space
//   let days = 0,
//     time = "00:00";
//   console.log(duration, parts);

//   // Extract days and time from the input string
//   if (parts.length > 2) {
//     days = parseInt(parts[0]);
//     time = parts[2];
//   } else if (parts.length === 1) {
//     if (parts[0].includes(":")) {
//       time = parts[0];
//     } else {
//       days = parseInt(parts[0]);
//     }
//   }

//   // Split time into hours and minutes
//   const [hours, minutes] = time.split(":").map(Number);

//   // Construct the output based on the specified conditions
//   if (days === 0 && hours === 0 && minutes === 0) {
//     return "0 days 00:00";
//   } else if (days === 0) {
//     return ` ${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes
//       } `;
//   } else if (hours === 0 && minutes === 0) {
//     return ` ${days} ${days === 1 ? "day" : "days"} `;
//   } else {
//     return ` ${days} ${days === 1 ? "day" : "days"} ${hours < 10 ? "0" + hours : hours
//       }:${minutes < 10 ? "0" + minutes : minutes} `;
//   }
// }

function capitalizeFirstLetterOfEachWord(str) {
  return str
    .split(' ') // Split the string by spaces into an array of words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
    .join(' '); // Join the array back into a single string
}
const Project = () => {
  const [{ sysConfig, userInfo }, dispatch] = useStateValue();

  const navigate = useNavigate();

  const transformedArray = (inputArray) => {
    if (inputArray) {
      const output = inputArray.map((obj) => {
        const key = Object.keys(obj)[0];
        const value = obj[key];
        return { id: key, value: value };
      });
      return output;
    }
    return [];
  };

  // ********************************************************************* filter Data *************************************************
  const [searchQuery, setSearchQuery] = useState("");
  const [userFilter, setUserFilter] = useState("");
  const [entityFilter, setEntityFilter] = useState("");
  const [isStatusFilter, setIsStatusFilter] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredData, setFilteredData] = useState([]);
  const [currentItems, setCurrentItems] = useState([]);
  const searchInput = useRef(null);
  const [totalPages, setTotalPages] = useState(0);
  const fetchReport = async (userFilter) => {
    // Perform the API call to fetch company info
    dispatch({ type: "SET_LOADING", status: true });

    try {
      const response = await listOfProject(userFilter);
      if (response?.status === 200) {
        // setReportData(response.data.data);
        // setFilteredData(response.data.data);
      } else {
        // toast.error("Something went wrong.");
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
    dispatch({ type: "SET_LOADING", status: false });
  };

  const { isLoading, data, refetch } = useQuery({
    queryKey: ["report-list", userFilter],
    queryFn: () => fetchReport(userFilter),
    enabled: false,
    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });
  const [reportData, setReportData] = useState([]);
  const {
    isLoading: isUserListLoading,
    data: useList,
    refetch: userListreFetch,
  } = useQuery({
    queryKey: ["new-re-form-data"],
    queryFn: async () => {
      // Perform the API call to fetch company info
      try {
        dispatch({ type: "SET_LOADING", status: true });

        const response = await getAddNewTaskDetail();
        if (response?.status === 200) {
          setUserList(response.data.data.users_list);
          setTaskStatusFilter(transformedArray(response.data.data.status_list));

        } else if (response?.response) {
          toast.error(response.response.data.status);
        }
        dispatch({ type: "SET_LOADING", status: false });

        return response;
      } catch (error) {
        console.error("Error fetching data:", error); // Log any errors that occur
        throw error;
      }
    },
    // enabled: isAdmin(userInfo) ? true : false,
  });
  const [userList, setUserList] = useState(
    data?.status === 200 ? data.data.data.users_list : []
  );
  const [totalTaskData, setTotalTaskData] = useState({});

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      entity: "task",
      userFilter: "",
      reportStatus: "all",
      taskStatus: "all",
      period: ""

    },
  });

  const watchedFields = watch();
  const onSubmit = async (data) => {
    console.log("asdasdadsad")

    if (!(watchedFields.startDate && watchedFields.endDate)) {
      toast.error("Please select start date and end date.")
    }
    else if (watchedFields.startDate && !watchedFields.endDate) {
      toast.error("Please select end date.")
    }
    else if (watchedFields.endDate && !watchedFields.startDate) {
      toast.error("Please select start date.")

    }
    else if (watchedFields.startDate && watchedFields.endDate) {
      const start = new Date(data.startDate);
      const end = new Date(data.endDate);
      const diffInMs = end - start;
      // Convert the difference from milliseconds to days
      const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
      if (diffInDays > parseInt(sysConfig["Report Days Upto"])) {
        start.setDate(start.getUTCDate() + parseInt(sysConfig["Report Days Upto"]))


        toast.error(`Maximum end date can be ${start.toISOString().split('T')[0]}`)
      }

      else {
        // **************************** convert duration end ****************************

        dispatch({ type: "SET_LOADING", status: true });
        try {
          const re = await getReports(data);
          console.log(re)

          if (re?.status === 200) {
            // if (data.reportStatus === "task_totals") {
            //   setTotalTaskData(re.data.data)

            // }
            // else {

            setReportData(re.data.data);
            setFilteredData(re.data.data);
            // }
            setReportStatus(data.reportStatus)
            setEntityType(data.entity)
            setAppliedFilter(data)
            if (data.reportStatus === "task_totals") {

              setTitle(capitalizeFirstLetterOfEachWord(`User Task Summary Report`))
            }
            else {

              setTitle(capitalizeFirstLetterOfEachWord(`${data.reportStatus} ${data.entity} Report`))
            }
            if ((buttonRef.current && re.data.data.length > 0) || data.reportStatus === "task_totals") {
              buttonRef.current.click();
            }
          }
          else if (re?.response) {
            setReportData([]);
            setFilteredData([]);
            setReportStatus(data.reportStatus)
            toast.error(re.response.data.message)
          }
        } catch { }
        dispatch({ type: "SET_LOADING", status: false });
      }
    }



  };
  useEffect(() => {
    filterData(searchQuery);
    setCurrentPage(1);
  }, [searchQuery]);

  useEffect(() => {
    const startIdx =
      (currentPage - 1) * Number(sysConfig["Rows in MultiLine List"]);
    setCurrentItems(
      filteredData.slice(
        startIdx,
        startIdx + Number(sysConfig["Rows in MultiLine List"])
      )
    );
    console.log("dDddddddddddddddddddddd", filteredData.slice(
      startIdx,
      startIdx + Number(sysConfig["Rows in MultiLine List"])
    ))
    setTotalPages(
      Math.ceil(
        filteredData.length / Number(sysConfig["Rows in MultiLine List"])
      )
    );
  }, [currentPage, filteredData]);

  useEffect(() => {
    filterData(searchQuery, userFilter, isStatusFilter);
    const totalPageCount = Math.ceil(
      filteredData.length / Number(sysConfig["Rows in MultiLine List"])
    );
    setTotalPages(
      Math.ceil(
        filteredData.length / Number(sysConfig["Rows in MultiLine List"])
      )
    );

    if (totalPageCount !== 0 && totalPageCount < currentPage) {
      setCurrentPage(totalPageCount);
    }
  }, [reportData]);



  const setDefaultValue = () => { };

  const handleUserChange = (e) => {
    const type = e.target.value;
    setUserFilter(type);
  };
  const handleEntityChange = (e) => {
    const type = e.target.value;
    setEntityFilter(type);
  };

  const handleIsStatusChange = (e) => {
    setIsStatusFilter(e.target.value);
    refetch();

    // setDefaultValue();
  };
  const handleSearch = () => {

    const query = searchInput.current.value.toLowerCase();
    setSearchQuery(query);
    refetch();
    // setDefaultValue();
  };
  const filterData = (query) => {
    let filtered = reportData;

    if (query) {
      filtered = filtered.filter(
        (item) =>
          item?.task_name?.toLowerCase().includes(query) ||
          item?.task_description?.toLowerCase().includes(query) ||
          item?.project_name?.toLowerCase().includes(query) ||
          item?.project_description?.toLowerCase().includes(query)
      );
    }

    // if (user) {
    //   filtered = filtered.filter(
    //     (item) => item.ProjLead === user ||
    //       item.AllocBy === user ||
    //       item?.tasks_list.some(task => (task.TaskLead === user || task.AllocBy === user))
    //   );
    // }

    // if (status) {
    //   filtered = filtered.filter(
    //     (item) => item?.Status?.idx === parseInt(status)
    //   );
    // }

    setFilteredData(filtered);
    // setCurrentPage(1);
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setDefaultValue();
  };

  // ********************************************** get data start ****************************************************



  // ************************************************************* reset password modal **********************************

  const [confirmationShow, setConfirmationShow] = useState(false);
  const [funHandler, setFunHandler] = useState();
  const [changeUserFilter, setChangeUserFilter] = useState(true);
  const [taskStatusFilter, setTaskStatusFilter] = useState([]);
  const [reportStatusFilter, setReportStatusFilter] = useState([]);
  const [appliedFilter, setAppliedFilter] = useState({});
  const [entityType, setEntityType] = useState("task");
  const [reportStatus, setReportStatus] = useState("all");
  const [title, setTitle] = useState("Select Report");
  const buttonRef = useRef(null);
  const handleConfirmationClose = () => {
    setConfirmationShow(false);
  };
  const handleConfirmationShow = () => setConfirmationShow(true);


  useEffect(() => {
    let statusList
    if (watchedFields.entity === "task") {
      if (userInfo.user_type === "SysAdm") {

        statusList = [
          { key: "all", value: "All" },
          { key: "open", value: "Open" },
          { key: "overdue", value: "Overdue" },
          { key: "delayed", value: "Delayed" },
          { key: "completing", value: "Completing" },
          { key: "completed", value: "Completed" },
          { key: "task_totals", value: "Task Totals" },
        ]
      }
      else {

        statusList = [
          { key: "all", value: "All" },
          { key: "open", value: "Open" },
          { key: "overdue", value: "Overdue" },
          { key: "delayed", value: "Delayed" },
          { key: "completing", value: "Completing" },
          { key: "completed", value: "Completed" },
        ]
      }



    }
    else {
      statusList = [
        { key: "all", value: "All" },
        { key: "open", value: "Open" },
        { key: "overdue", value: "Overdue" },
        { key: "delayed", value: "Delayed" },

      ]

    }
    setReportStatusFilter(statusList)
  }, [watchedFields.entity, userInfo]);


  useEffect(() => {
    setValue("userFilter", userInfo?.user_code)
  }, [userInfo])
  useEffect(() => {
    const formatDateToInput = (date) => {
      const year = date.getFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-based
      const day = String(date.getUTCDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    const today = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getUTCDate() - 30);
    setValue("startDate", formatDateToInput(thirtyDaysAgo))
    setValue("endDate", formatDateToInput(today))
  }, [])

  const exportReport = async (actionTypeArg) => {
    dispatch({ type: "SET_LOADING", status: true });
    try {
      const re = await createUserActivityReports(watchedFields, actionTypeArg);

      if (re?.status === 201) {

        generateExcel(filteredData, reportStatus, appliedFilter, userInfo)
      }
      else if (re?.response) {

        toast.error(re.response.data.message)
      }
    } catch { }
    dispatch({ type: "SET_LOADING", status: false });

  }

  return (
    <div id="app-content">
      {/* Container fluid */}
      <div className="app-content-area">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              {/* Page header */}
              <div className="mb-5">
                <h3 className="mb-0 ">
                  Report
                </h3>
              </div>
            </div>
          </div>
          <div>
            {/* row */}
            <div className="row">
              <div className="col-12">
                {/* card */}
                <div className="card mb-4">
                  <div className="card-header  ">

                    <>
                      <div className="accordion mb-4 " id="accordionExample">
                        <div className="accordion-item ">
                          <h2 className="accordion-header bg-white" id="headingOne">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" ref={buttonRef}
                              data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                              <strong>

                                {title}
                              </strong>
                            </button>
                          </h2>
                          <div id="collapseOne" className="accordion-collapse collapse show p-3"
                            aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                            <form onSubmit={handleSubmit(onSubmit)} >

                              <div className="row justify-content-between">


                                <div className="col-lg-4 col-md-4 col-6   mt-md-3">
                                  <label className="form-label">
                                    Entity{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  {(
                                    <select
                                      className="form-select mb-4"
                                      aria-label="Default select example"
                                      {...register("entity", {
                                        onChange: (e) => {
                                          if (e.target.value !== "task") {
                                            setValue("taskStatus", "all")
                                          }
                                        }
                                      })}
                                    >
                                      <option disabled>Select Entity</option>
                                      <option selected="Task" value={"task"}>
                                        Task
                                      </option>
                                      <option value={"project"}>
                                        Project
                                      </option>
                                    </select>
                                  )}
                                </div>
                                <div className="col-lg-4 col-md-4 col-6   mt-md-3">
                                  <label className="form-label">
                                    Report Type{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  {(
                                    <select
                                      className="form-select mb-4"
                                      aria-label="Default select example"
                                      {...register("reportStatus", {
                                        onChange: (e) => {
                                          if (e.target.value !== "all") {
                                            setValue("taskStatus", "all")
                                          }
                                        }
                                      })}
                                    >
                                      <option disabled>Select Status</option>

                                      {reportStatusFilter.map((item) => (
                                        <option value={item.key}>{item.value}</option>
                                      ))}
                                    </select>
                                  )}
                                </div>
                                <div className="col-lg-4 col-md-4 col-6   mt-md-3">
                                  <label className="form-label">
                                    Task Status{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  {(
                                    <select
                                      className="form-select"
                                      aria-label="Default select example"
                                      disabled={watchedFields.entity !== "task" || watchedFields.reportStatus !== "all"}
                                      {...register("taskStatus", {

                                      })}
                                    >
                                      <option disabled>Select Task Status</option>
                                      <option selected="" value={"all"}>
                                        All
                                      </option>
                                      {taskStatusFilter.map((item) => (
                                        <option value={item.id}>{item.value}</option>
                                      ))}
                                    </select>
                                  )}
                                </div>
                                <div className="col-lg-4 col-md-4 col-6   mt-md-3">
                                  <label className="form-label">
                                    User{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  {(
                                    // <select
                                    //   className="form-select mb-4"
                                    //   aria-label="Default select example"
                                    //   disabled={!isAdmin(userInfo)}
                                    //   value={watchedFields.userFilter}
                                    //   {...register("userFilter", {
                                    //     onChange: (e) => {
                                    //       if (e.target.value === "all") {
                                    //         setValue("byOrToMe", "all")
                                    //       }
                                    //     }
                                    //   })}
                                    // >
                                    //   <option disabled>Select User</option>

                                    //   <option selected="" value={"all"}>
                                    //     All
                                    //   </option>
                                    //   {userList.map((item) => (
                                    //     <option value={item}>{item}</option>
                                    //   ))}
                                    // </select>
                                    <Select
                                      // className="form-select"
                                      styles={customStyles}
                                      value={watchedFields.userFilter ? { label: watchedFields.userFilter === "all" ? "All" : watchedFields.userFilter, value: watchedFields.userFilter } : { label: "All", value: "all" }}
                                      isDisabled={!isAdmin(userInfo)}
                                      placeholder="Select user."
                                      // onChange={handleUserChange}
                                      onChange={(option) => {
                                        setValue("userFilter", option.value)
                                        if (option.value === "all") {
                                          setValue("byOrToMe", "all")
                                        }
                                      }}

                                      options={[{ label: "Select a user", value: "Select a user", isDisabled: true }, { label: "All", value: "all" }, ...convertToUserOptions(userList)]}
                                    />
                                  )}
                                </div>
                                <div className="col-lg-4 col-md-4 col-6   mt-md-3">
                                  <label className="form-label">
                                    Allocated {" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  {(
                                    <select
                                      className="form-select mb-4"
                                      aria-label="Default select example"
                                      // disabled={!isAdmin(userInfo)}
                                      disabled={watchedFields.userFilter === "all"}

                                      value={watchedFields.byOrToMe}
                                      {...register("byOrToMe", {
                                      })}
                                    >
                                      <option disabled>Select User</option>
                                      <option selected="" value={"all"}>
                                        Both
                                      </option>
                                      <option selected="" value={"to_me"}>
                                        To Me
                                      </option>
                                      <option value={"by_me"}>
                                        By Me
                                      </option>
                                    </select>
                                  )}
                                </div>
                                {/* form group */}
                                <div className=" col-lg-4  col-md-4 col-6 mt-md-3">
                                  <label className="form-label">
                                    Start date{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <div
                                    className="input-group me-3 flatpickr rounded flatpickr-input"
                                    readOnly="readonly"
                                  >
                                    <input
                                      className="form-control "
                                      type="date"
                                      placeholder="Select Date"
                                      aria-describedby="basic-addon2"
                                      format="dd/mm/yyyy"

                                      min="1000-01-01T00:00"
                                      max="9999-12-31T23:59"
                                      {...register("startDate", {
                                        // required: "Start Date is required",

                                      })}
                                    />
                                  </div>
                                  {errors.startDate && (
                                    <div className="error">
                                      {errors.startDate.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className=" col-lg-4  col-md-4 col-6">
                                  <label className="form-label">
                                    End Date{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <div
                                    className="input-group me-3 flatpickr rounded flatpickr-input"
                                    readOnly="readonly"
                                  >
                                    <input
                                      className="form-control "
                                      type="date"
                                      placeholder="dd-mm-yyyy"
                                      //  pattern="\d{2}-\d{2}-\d{4}"

                                      min="1000-01-01T00:00"
                                      max="9999-12-31T23:59"

                                      {...register("endDate", {
                                        // required: "End Date is required",

                                      })}
                                    />
                                  </div>
                                  {errors.endDate && (
                                    <div className="error">
                                      {errors.endDate.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="row mt-4 p-3 justify-content-center">
                                <button className="btn btn-primary col-12 col-lg-2"> Apply</button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      {appliedFilter.reportStatus !== "task_totals" &&
                        <div className=" col-lg-12 col-md-12 mt-md-3 d-flex ">
                          <input
                            ref={searchInput}
                            type="search"
                            className="form-control "
                            // value={searchQuery}
                            onChange={(e) => {
                              if (e.target.value === "") {
                                handleSearch();
                              }
                            }}
                            placeholder="Search for Name & Description."
                          />
                          <div
                            className="btn btn-primary ms-3"
                            onClick={() => handleSearch()}
                          >
                            <IoMdSearch size={25} />
                          </div>
                        </div>}



                    </>
                  </div>
                  {!isLoading ? (
                    <>
                      {(currentItems.length > 0) && <div className="d-flex justify-content-end ">
                        {appliedFilter.reportStatus === "task_totals" ?
                          <div className="btn btn-primary col-lg-2 col-md-4 m-4" onClick={() => exportReport("ExportReport")} >Export to xlsx</div> :
                          <div className="btn btn-primary col-lg-2 col-md-4 m-4" onClick={() => exportReport("PrintReport")} >Export to xlsx</div>
                        }
                      </div>}
                      <div className="card-body">
                        <div className="table-responsive table-card">
                          {currentItems.length > 0 ? (
                            <>
                              {
                                appliedFilter.reportStatus === "task_totals" ?
                                  <table className="table text-nowrap mb-0 responsive-table table-centered table-hover">
                                    <thead className="table-light">
                                      <tr>
                                        <th className="   ">
                                          Srl
                                        </th>
                                        <th className="   ">
                                          User Name
                                        </th>
                                        <th className=" pe-0  ">
                                          Total
                                        </th>
                                        <th className="">
                                          Efficiency Percentage
                                          <br />
                                          Done Ok / Done All
                                        </th>
                                        <th className="">
                                          Done Ok
                                        </th>
                                        <th className="">
                                          Done
                                          <br />
                                          Delayed
                                        </th>
                                        <th className="">
                                          Pending Ok
                                        </th>
                                        <th className="">
                                          Pending
                                          <br />
                                          Delayed
                                        </th>
                                        <th className="">
                                          InProcess
                                          <br />
                                          Ok
                                        </th>
                                        <th className="">
                                          InProcess
                                          <br />
                                          Delayed
                                        </th>
                                        <th className="">
                                          Under
                                          <br />
                                          Review
                                        </th>
                                        <th className="">
                                          Cancelled
                                        </th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {currentItems.map((item, index) => (
                                        <tr

                                        >
                                          <td data-label1="Srl">{item.srl}</td>
                                          <td data-label1="User Name">{item.user_name}</td>
                                          <td data-label1="Total">{item.total_tasks}</td>
                                          <td data-label1="Efficiency Percentage" data-label2="Done Ok / Done All">{item?.efficiency_percentage ? item?.efficiency_percentage.toFixed(2) : 0} </td>
                                          <td data-label1="Done Ok">{item.done_on_time}</td>
                                          <td data-label1="Done" data-lable2="Delayed">{item.done_late}</td>
                                          <td data-label1="Pending ok">{item.pending_on_time}</td>
                                          <td data-label1="Pending" data-lable2="Delayed">{item.pending_late}</td>
                                          <td data-label1="InProgress Ok">{item.in_progress_on_time}</td>
                                          <td data-label1="InProgress" data-lable2="Delayed">{item.in_progress_late}</td>
                                          <td data-label1="Under" data-lable2="Review">{item.under_review}</td>
                                          <td data-label1="Cancelled">{item.cancelled}</td>



                                        </tr>
                                      ))}
                                    </tbody>
                                  </table> :
                                  <table className="table text-nowrap mb-0 responsive-table table-centered table-hover">
                                    <thead className="table-light">
                                      <tr>
                                        <th className="   ">
                                          Srl
                                        </th>
                                        {entityType === "task" ? <th>Project</th> : ""}

                                        <th className=" pe-0  ">
                                          {" "}
                                          {entityType === "task" ? "Task" : "Project"}
                                          <br />
                                          Description
                                        </th>
                                        <th className="">
                                          Duration
                                        </th>
                                        <th className="">
                                          Actual End
                                          <br /> Actual Start
                                        </th>
                                        <th className="">
                                          Planned End
                                          <br /> Planned Start
                                        </th>

                                        <th className="">
                                          {reportStatus === "overdue" ? "Overdue " : "Delay "}
                                          Days
                                        </th>
                                        {/* <th>Approx Days</th> */}
                                        <th>
                                          By <br />
                                          To
                                        </th>
                                        <th>Status</th>
                                        {reportStatus !== "overdue" ? <th> Delay Reason</th> : ""}
                                        {/* <th> Delay Reason</th> */}
                                        <th>Comment</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {currentItems.map((item, index) => (
                                        <tr
                                          id={`user-${index}`}
                                          className={""}
                                        >
                                          <td
                                            data-label1="Srl"

                                          >
                                            {item.srl}
                                          </td>
                                          {entityType === "task" ? <td data-label1="Project" style={{
                                            maxWidth: "350px",
                                            minWidth: "220px",
                                            textWrap: "wrap",
                                          }}>
                                            <div className="div truncate">

                                              {item?.project_name}
                                            </div>
                                          </td> : ""}

                                          <td
                                            data-label1="Project"
                                            data-label2="Description"
                                            style={{
                                              maxWidth: "350px",
                                              minWidth: "220px",
                                              textWrap: "wrap",
                                            }}
                                          >
                                            <div className="d-flex flex-column truncate">
                                              <strong
                                                className="cursor-pointer"
                                              >
                                                {entityType === "task" ? item?.task_name : item?.project_name}
                                              </strong>
                                              {/* <br /> */}
                                              <div className="truncate">
                                                <small>
                                                  {entityType === "task" ? item?.task_description : item?.project_description}

                                                  {/* {project?.project_description} */}
                                                </small>
                                              </div>
                                            </div>
                                          </td>
                                          <td
                                            data-label1="Duration"
                                          // style={{
                                          //   textWrap: "wrap",
                                          //   textAlign: "right",
                                          // }}


                                          >
                                            {item?.duration ? formatTimeDuration(item?.duration) : "--"}
                                          </td>

                                          <td
                                            data-label1="Actual End"
                                            data-label2="Actual Start"

                                            style={{
                                              width: "205px",
                                            }}
                                          >
                                            <div className="d-flex flex-column">

                                              {/* <div className="bg-success text-white ps-2 pe-2 rounded"> */}
                                              <div
                                                className={`bg-light text-dark  ps-2 pe-2 rounded text-center mb-2 `}
                                              >
                                                {
                                                  formatDateTimetoAmPm(item?.actual_end_date)


                                                }
                                              </div>
                                              {/* <br /> */}
                                              <div
                                                className={`bg-light text-dark  ps-2 pe-2 rounded text-center`}
                                              >
                                                {
                                                  formatDateTimetoAmPm(item?.actual_start_date)
                                                }
                                              </div>
                                            </div>
                                          </td>
                                          <td
                                            data-label1="Planned End"
                                            data-label2="Planned Start"

                                            style={{
                                              width: "180px",
                                            }}
                                          >
                                            {/* <div className="bg-success text-white ps-2 pe-2 rounded"> */}
                                            <div className="d-flex flex-column">

                                              <div
                                                className={getClassNamesOfEndDate(
                                                  item.ActualEndDtTm,
                                                  item.EndDtTm,
                                                  item.Status?.text
                                                )}
                                              >
                                                {
                                                  formatDateTimetoAmPm(item?.end_date)
                                                }
                                              </div>
                                              <div
                                                className={getClassNamesOfStartDate(
                                                  item.ActualStDtTm,
                                                  item.StartDtTm,
                                                  item.Status?.text
                                                )}
                                              >
                                                {
                                                  formatDateTimetoAmPm(item?.start_date)
                                                }
                                              </div>
                                            </div>
                                          </td>

                                          <td
                                            data-label1="Delay Days"
                                            style={{
                                              maxWidth: "150px",
                                              textWrap: "wrap",
                                              textAlign: "right",
                                            }}
                                          >
                                            {item?.delay_days ? formatTimeDuration(item?.delay_days) : "--"}
                                          </td>

                                          <td
                                            data-label1="By"
                                            data-label2="To"

                                            // className="truncate"
                                            style={{
                                              maxWidth: "150px",
                                              textWrap: "wrap",
                                              // textAlign: "center",
                                            }}
                                          >
                                            <div className="d-flex flex-column">

                                              <div className="truncate-1 mb-2">
                                                <strong>{item?.alloc_by_name}</strong>
                                              </div>
                                              {/* <br /> */}
                                              <div className="truncate-1">
                                                {item?.lead_name}
                                              </div>
                                            </div>
                                          </td>
                                          <td
                                            data-label1="Status"


                                            style={{
                                              width: "120px",
                                              textWrap: "wrap",
                                              textAlign: "center",
                                            }}
                                          >
                                            <div
                                              className={getClassNamesOfStatus(
                                                item.status?.text
                                              )}
                                            >
                                              {item?.status?.text}
                                            </div>
                                          </td>
                                          {reportStatus !== "overdue" ?
                                            <td
                                              data-label1="Delay Reason."
                                            >
                                              {item?.delay_reason ? item?.delay_reason : "--"}

                                            </td>

                                            : ""}
                                          {console.log(item)}
                                          <td
                                            data-label1="Comment"
                                            style={{
                                              maxWidth: "350px",
                                              minWidth: "220px",
                                              textWrap: "wrap",
                                            }}
                                          >
                                            <div className="truncate">

                                              {item?.comment?.Cancel && <>Cancel Comment:- {item?.comment?.Cancel} <br /></>}
                                            </div>
                                            <div className="truncate">

                                              {item?.comment?.Closing && <>Closing Comment:- {item?.comment?.Closing} <br /></>}
                                            </div>
                                            <div className="truncate">

                                              {item?.comment?.Rejection && <>Rejection Comment:- {item?.comment?.Rejection} <br /></>}
                                            </div>
                                            <div className="truncate">

                                              {!(item?.comment?.Cancel || item?.comment?.Closing || item?.comment?.Rejection) && <>--</>}
                                            </div>

                                          </td>


                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                              }
                            </>

                          ) : (
                            <div className="m-5 fs-3">
                              <strong>No records found.!</strong>
                            </div>
                          )}
                        </div>
                      </div>
                      {filteredData.length > 0 && appliedFilter.reportStatus !== "task_totals" && (
                        <div className="card-footer d-md-flex justify-content-between align-items-center">
                          <span>
                            Showing{" "}
                            {currentPage *
                              Number(sysConfig["Rows in MultiLine List"]) -
                              Number(sysConfig["Rows in MultiLine List"]) +
                              1}{" "}
                            to{" "}
                            {currentPage *
                              Number(sysConfig["Rows in MultiLine List"]) >=
                              filteredData.length
                              ? filteredData.length
                              : currentPage *
                              Number(
                                sysConfig["Rows in MultiLine List"]
                              )}{" "}
                            of {filteredData.length} entries
                          </span>
                          <nav className="mt-2 mt-md-0">
                            <ul className="pagination mb-0 ">
                              <li
                                className="page-item "
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  if (currentPage > 1) {
                                    handlePageChange(currentPage - 1);
                                  }
                                }}
                              >
                                <div
                                  className={`page-link ${currentPage === 1 ? "disabled" : ""
                                    } `}
                                >
                                  Previous
                                </div>
                              </li>
                              {Array(totalPages ? totalPages : 0)
                                .fill()
                                .map((item, index) => (
                                  <li
                                    style={{ cursor: "pointer" }}
                                    className={`${currentPage === index + 1
                                      ? "page-item active"
                                      : "page-item"
                                      } ${currentPage + 2 >= index + 1 &&
                                        index + 1 > currentPage - 2
                                        ? // currentPage - 2 < index + 1
                                        "d-block"
                                        : "d-none"
                                      }`}
                                    onClick={() => {
                                      handlePageChange(index + 1);
                                    }}
                                  >
                                    <div className="page-link">{index + 1}</div>
                                  </li>
                                ))}

                              <li className="page-item">
                                <div
                                  style={{ cursor: "pointer" }}
                                  className={`page-link ${totalPages === currentPage ? "disabled" : ""
                                    } `}
                                  onClick={() => {
                                    if (totalPages > currentPage) {
                                      handlePageChange(currentPage + 1);
                                    }
                                  }}
                                >
                                  Next
                                </div>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="m-5 fs-3">
                      <strong>Fetching records..</strong>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModal
        show={confirmationShow}
        onHide={handleConfirmationClose}
        funHandler={funHandler}
      />
    </div>
  );
};

export default Project;
